"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingProvider = exports.AdvertisingContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ApiAdvertisingRepo_1 = require("../../../modules/advertising/infra/ApiAdvertisingRepo");
const getMachines_1 = require("../../../modules/advertising/app/getMachines");
const getMachinesSummary_1 = require("../../../modules/advertising/app/getMachinesSummary");
const setMachineAdvertising_1 = require("../../../modules/advertising/app/setMachineAdvertising");
const getAds_1 = require("../../../modules/advertising/app/getAds");
const getAdMachines_1 = require("../../../modules/advertising/app/getAdMachines");
const createAd_1 = require("../../../modules/advertising/app/createAd");
const getAd_1 = require("../../../modules/advertising/app/getAd");
const updateAd_1 = require("../../../modules/advertising/app/updateAd");
const deleteAd_1 = require("../../../modules/advertising/app/deleteAd");
const getAdUploadUrl_1 = require("../../../modules/advertising/app/getAdUploadUrl");
const getMachineAds_1 = require("../../../modules/advertising/app/getMachineAds");
const saveMachineAds_1 = require("../../../modules/advertising/app/saveMachineAds");
const getAvailableAds_1 = require("../../../modules/advertising/app/getAvailableAds");
exports.AdvertisingContext = (0, react_1.createContext)(null);
const AdvertisingProvider = ({ children, }) => {
    const value = (0, react_1.useMemo)(() => {
        const repo = (0, ApiAdvertisingRepo_1.createApiAdvertisingRepo)();
        return {
            getMachines: () => (0, getMachines_1.getMachines)(repo),
            getMachinesSummary: () => (0, getMachinesSummary_1.getMachinesSummary)(repo),
            setMachineAdvertising: (machineId, advertisingEnabled) => (0, setMachineAdvertising_1.setMachineAdvertising)(repo, machineId, advertisingEnabled),
            getAds: (page, pageSize) => (0, getAds_1.getAds)(repo, page, pageSize),
            getAdMachines: (adId, page, pageSize) => (0, getAdMachines_1.getAdMachines)(repo, adId, page, pageSize),
            createAd: (payload) => (0, createAd_1.createAd)(repo, payload),
            getAd: (adId) => (0, getAd_1.getAd)(repo, adId),
            updateAd: (adId, payload) => (0, updateAd_1.updateAd)(repo, adId, payload),
            deleteAd: (adId) => (0, deleteAd_1.deleteAd)(repo, adId),
            getAdUploadUrl: (file) => (0, getAdUploadUrl_1.getAdUploadUrl)(repo, file),
            getMachineAds: (machineId) => (0, getMachineAds_1.getMachineAds)(repo, machineId),
            saveMachineAds: (machineId, payload) => (0, saveMachineAds_1.saveMachineAds)(repo, machineId, payload),
            getAvailableAds: (machineId) => (0, getAvailableAds_1.getAvailableAds)(repo, machineId),
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.AdvertisingContext.Provider, { value: value, children: children }));
};
exports.AdvertisingProvider = AdvertisingProvider;
